wbApp.filter('wbAvailabilityScheduleFilter', [function () {

    function printPeriod(period) {
        return moment(period.start).format('HH:mm') + "-" + moment(period.end).format('HH:mm');
    }

    return function (input) {

        var ret = "";

        _.forEach(input.periods, function (p) {
            if (ret) {
                ret = ret + ", " + printPeriod(p);
            } else {
                ret = ret + printPeriod(p);
            }
            
        });

        if (ret !== "") {
            return "(" + ret + ")"
         }

        return ret;
    };
}]);